<template>
  <v-container grid-list-md v-if="this.$store.getters.programsFetched && this.application">
    <v-layout row wrap class="btn-wrapper">
      <v-dialog v-model="showDialog"
        persistent
        max-width="900px"
      >
        <v-form>
          <v-card>
            <v-card-text>
              <v-container grid-list-md class="no-top-padding">
                <v-layout row wrap>

                  <v-flex xs12  mb-4>
                    <h2 class="text-xs-center">
                      {{$t('message.application', [application.companyName, application.applicationId]) }}
                    </h2>
                  </v-flex>

                  <v-flex xs4>
                      <div class="gray--text">
                        Create Date
                      </div>
                      {{ formatDateOnly(application.createDate) }}
                  </v-flex>

                  <v-flex xs4>
                    <div class="gray--text">
                      Last Submit Date
                    </div>
                    {{ formatDateOnly(application.lastSubmitDate) }}
                  </v-flex>

                  <v-flex xs4 v-if="application.deleted">
                    <div class="gray--text">
                      Expiration Date
                    </div>
                    {{ formatDateOnly(application.expirationDate) }}
                  </v-flex>

                  <v-flex xs4 v-if="!application.deleted">
                    <v-menu
                      :close-on-content-click="false"
                      v-model="startDateMenu">
                      <v-text-field
                        slot="activator"
                        :disabled="loading"
                        v-model="application.expirationDate"
                        label="Expiration Date"
                        prepend-icon="event"
                        readonly></v-text-field>
                      <v-date-picker v-model="application.expirationDate"
                                     :min="pickerExpireMinDate"
                                     :max="pickerExpireMaxDate"
                                     no-title @input="startDateMenu = false">
                      </v-date-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs12 mt-4 style="min-height: 10em">
                    <v-data-table
                      :headers="lenderHeaders"
                      :items="application.lenders"
                      hide-actions
                      class="elevation-1"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.applicationSubmitted }}</td>
                        <td>{{ props.item.failedApplicationSubmits }}</td>

                        <td>
                          <v-select
                            v-model="props.item.lenderStatus"
                            :items="lenderStatuses"
                            required
                          ></v-select>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>

                  <v-flex xs12>
                    <v-textarea
                      rows="8"
                      v-model="application.comment"
                      :label="$t('message.dealerApp.comment')"
                       solo
                      no-resize
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                flat
                class="btn-secondary"
                @click="showDialog=false"
              >{{ $t('message.cancel') }}</v-btn
              >
              <v-btn
                flat
                slot="activator"
                class="btn-primary"
                @click="updateApp"
                :disabled="loading"
              >
                {{ $t('message.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../../main.js'
import { EventBus } from '../../main.js'

export default {
  data: () => ({
    loading: false,
    showDialog: false,
    startDateMenu: false,
    pickerExpireMinDate: null,
    pickerExpireMaxDate: null,
    lenderHeaders: [
      {text: 'Lender', value: 'name', sortable: false, width: '30%'},
      {text: 'Submitted', value: 'applicationSubmitted', sortable: false, width: '20%'},
      {text: 'Failed Submissions', value: 'failedApplicationSubmits', sortable: false, width: '20%'},
      {text: 'Status', value: 'lenderStatus', sortable: false, width: '30%'}
    ],
  }),
  props: {
    application: Object,
    lenderStatuses: Array
  },
  methods: {
    setupExpireDatePicker() {
      this.pickerExpireMinDate = moment().add(1, 'days').toISOString().substr(0, 10);
      this.pickerExpireMaxDate = moment().add(60, 'days').toISOString().substr(0, 10);
    },
    updateApp() {
      this.loading = true
      this.application.expirationDate = moment(this.application.expirationDate).format("YYYY-MM-DDThh:mm:ss.000")
      axiosAuthInstance
        .post('api/v1/admin/app/update/', this.application)
        .then(response => {
          this.showDialog = false
          EventBus.$emit('closeAppEditDialog');
        })
        .catch(error => {
          this.notifyAxiosError(
            error,
            'There was an error updating the application'
          )
        })
        .then(() => {
          this.loading = false
        })
    }
  },
  beforeDestroy() {
    EventBus.$off('openAppEditDialog');
  },
  mounted: function () {
    this.setupExpireDatePicker()

    var vm = this;
    EventBus.$on('openAppEditDialog', function () {
      vm.showDialog = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AppEditDialog.vue